import { Nav } from "react-bootstrap";
//redux
import { useAppDispatch, useAppSelector } from "../../../hooks";
import { selectBoardData, setBoardData } from "../../../redux/reducer/board/boardSlice";

//-------------------------------------------------------------------
export default function ReportNav() {
    //redux
    const dispatch = useAppDispatch();
    const data = useAppSelector(selectBoardData);

    //view
    return (
        <Nav.Item>
            <Nav.Link
                active={data === "report"}
                eventKey="report-link"
                onClick={() => {
                    dispatch(setBoardData("report"));
                }}
            >
                Raporty
            </Nav.Link>
        </Nav.Item>
    );
}
